import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../../styles/theme';
import { scrollbars, mozScrollbars, mediaQuery } from '../../../../styles/helpers';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      borderRadius: '8px 8px 0px 0px',
      background: 'linear-gradient(180deg, var(--x-accent-2-4) 38%, #FFF 0%)',
      bottom: -156,
      filter: 'drop-shadow(0px 4px 16px rgba(17, 18, 54, 0.16))',
      transition: 'all .3s',
      width: 435,

      [mediaQuery(breakpoints.mobile)]: {
        width: 'min(344px, 100%)',
      },
    },
    expanded: {
      bottom: 0,
    },
    headerContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      padding: 16,
    },
    headerLeft: {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
    },
    heading: {
      color: 'var(--x-bg-1)',
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '20px',
    },
    toggleIcon: {
      marginRight: 16,
      padding: '4px 0',
      transition: 'all 0.3s',
      height: 20,
      width: 20,

      '& path': {
        fill: '#fff',
      },
    },
    toggleIconUp: {
      transform: 'rotate(-180deg)',
    },
    textareaContainer: {
      borderRadius: 8,
      backgroundColor: '#fff',
      border: '1px solid #e0e0e0',
      height: 100,
      margin: '0 18px 8px 18px',
      padding: '12px 32px 12px 12px',
      position: 'relative',
    },
    textarea: {
      backgroundColor: '#fff',
      border: 0,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '19px',
      height: '100%',
      resize: 'none',
      width: '100%',
      maxWidth: '100%',

      ...scrollbars({
        thumbBackgroundColor: '#CBCBCB',
        thumbHoverBackgroundColor: '#B7B7B7',
      }),
      ...mozScrollbars('#CBCBCB'),
    },
    textareaWithAscii: {
      whiteSpace: 'pre',
      fontFamily: 'monospace',
    },
    close: {
      bottom: 116,
      cursor: 'pointer',
      padding: 2,
      position: 'absolute',
      right: 24,

      [mediaQuery(breakpoints.mobile)]: {
        right: 26,
      },
    },
    closeIcon: {
      width: 24,
      '& path': {
        fill: 'var(--x-textf-field-color-1)',
      },
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      height: 32,
    },
    copyButton: {
      borderRadius: 72,
      fontSize: 14,
    },
    shareButton: {
      fontSize: 14,
      '&>span': {
        gap: 4,
      },
    },
    shareButtonIcon: {
      width: 16,
      height: 16,
    },
    footer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      marginInline: 16,
      marginBlockEnd: 16,
    },
    history: {
      display: 'flex',
      justifyContent: 'space-between',
      width: 60,
    },
    historyIcon: {
      cursor: 'pointer',
      fill: 'var(--x-text-color-4)',
    },
    historyDisabled: {
      fill: 'var(--x-border-2)',
      opcacity: 0.4,
    },
    shareIcon: {
      cursor: 'pointer',
      fill: '#fff',
      height: 16,
      width: 16,
    },
    shareIconDisabled: {
      opacity: 0.4,
      cursor: 'initial',
    },
  }),
  {
    name: 'Editor',
  },
);

export default useStyles;
